<div class="login-page">
  <header class="login-header">
    <div class="brand">
      <img src="{{ BASE_IMG_URL }}assets/logo/rdo-logo.png" alt="Rede de Obras" class="brand-logo" />
    </div>
  </header>

  <main class="login-main">
    <div class="login-card">
      <h1 class="login-title">Entrar</h1>

      <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" novalidate>
        <div class="field" [class.field--error]="loginControl?.invalid && loginControl?.touched">
          <input
            id="login"
            type="text"
            formControlName="login"
            placeholder="Login"
            autocomplete="username"
            [attr.aria-describedby]="loginControl?.invalid && loginControl?.touched ? 'login-error' : null"
          />
          <span class="field__error" id="login-error" *ngIf="loginControl?.invalid && loginControl?.touched">
            {{ loginControl?.errors?.['leadingSpaces'] ? 'O login não pode começar com espaço.' : 'Informe seu login.' }}
          </span>
        </div>

        <div class="field" [class.field--error]="passwordControl?.invalid && passwordControl?.touched">
          <div class="field__password">
            <input
              id="password"
              [type]="showPassword ? 'text' : 'password'"
              formControlName="password"
              placeholder="Senha"
              autocomplete="current-password"
              [attr.aria-describedby]="passwordControl?.invalid && passwordControl?.touched ? 'password-error' : null"
            />
            <button
              type="button"
              class="field__toggle"
              (click)="togglePassword()"
              [attr.aria-label]="showPassword ? 'Ocultar senha' : 'Mostrar senha'"
            >
              <svg *ngIf="!showPassword" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                <circle cx="12" cy="12" r="3"/>
              </svg>
              <svg *ngIf="showPassword" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                <path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19M1 1l22 22"/>
              </svg>
            </button>
          </div>
          <span class="field__error" id="password-error" *ngIf="passwordControl?.invalid && passwordControl?.touched">
            Informe sua senha.
          </span>
        </div>

        <div class="form-error" *ngIf="errorMessage" role="alert">
          {{ errorMessage }}
        </div>

        <button type="submit" class="btn-entrar" [disabled]="isLoading">
          <span *ngIf="!isLoading">Entrar</span>
          <span *ngIf="isLoading" class="loading-spinner" aria-label="Carregando"></span>
        </button>
      </form>

      <button type="button" class="link-forgot" (click)="openForgotModal()">Esqueceu a senha?</button>

      <hr class="divider" />

      <p class="no-account">
        Não tem conta?<br>
        <a href="https://rededeobras.construmarket.com.br/" class="link-commercial" target="_blank">Fale com nossa equipe comercial</a>
      </p>
    </div>
  </main>

  <footer class="login-footer">
    <span>Uma plataforma</span>
    <img src="{{ BASE_IMG_URL }}assets/logo/construmarket.png" alt="Construmarket" height="22" class="footer-logo" />
    <img src="{{ BASE_IMG_URL }}assets/logo/convisao.webp" alt="ConVisão" width="auto" height="22" class="footer-logo" />
  </footer>

</div>

<app-modal-esqueceu-senha
  *ngIf="showForgotModal"
  (closed)="closeForgotModal()">
</app-modal-esqueceu-senha>